import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { ToastrService } from 'ngx-toastr';

// Define confirmation types enum
export enum ConfirmationType {
  DELETE_TEAM_MEMBER = 'delete_team_member',
  DELETE_LEAD = 'delete_lead',
  ATTACH_DOCUMENTS = 'attach_documents',
  DELETE_QUERY = 'delete_query',
  ATTACH_GENLINK = 'attach_genlink',
  CHANGES_MADE = 'change_made',
  RESET_PASSWORD = 'reset_password',
  DELETE_DOCUMENT = 'delete_document',
  DOWNLOAD_DOCUMENT = 'download_document',
  UPDATE_DOCUMENT_INFO = 'update_document_info',
  UPDATE_DOCUMENT_TAGS = 'update_document_tags',
  DELETE_APPROVAL = 'delete_approval',
  RESTORE_APPROVAL = 'restore_approval',
}

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css'],
    standalone: false
})
export class ConfirmationComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  files: File[] = [];
  parsedData: any[] = [];
  dragActive = false;
  uid:any;
  @Input() leadId: any;
  @Input() queryId: any;
  @Input() documentData: any; // For document-related operations
  @Input() confirmationType: ConfirmationType = ConfirmationType.DELETE_LEAD;
  @Input() selectedMatterIds: number[] = [];
  @Input() message: string = '';
  @Input() memData!: { id: string };
  @Input() isDeleteFlow: boolean = false;
  
  // Constants for confirmation messages
  readonly DELETE_TEAM_MEMBER= 'Are you sure you want to delete the team member?';
  readonly CHANGES_MADE_MESSAGE = 'Changes you made will not be saved. Do you want to continue?';
  readonly DELETE_LEAD_MESSAGE = 'Are you sure you want to delete the Lead?';
  readonly DELETE_QUERY_MESSAGE = 'Are you sure you want to delete the Query?';
  readonly ATTACH_DOCUMENTS_MESSAGE = 'Are you sure you want to attach these documents to the matter?';
  readonly ATTACH_GENLINK_MESSAGE = 'This link will be valid for 24hr. ' + ' Are you sure you want to share this link?';
  readonly RESET_PASSWORD_MESSAGE = 'Are you sure you want to reset the password?';
  readonly DELETE_DOCUMENT_MESSAGE = 'Are you sure you want to delete document?';
  readonly DOWNLOAD_DOCUMENT_MESSAGE = 'Are you sure you want to download this document?';
  readonly UPDATE_DOCUMENT_INFO_MESSAGE = 'Are you sure you want to update the document information?';
  readonly UPDATE_DOCUMENT_TAGS_MESSAGE = 'Are you sure you want to update the document tags?';
  readonly DELETE_APPROVAL_MESSAGE = 'Are you sure you want to permanently delete the document?';
  readonly RESTORE_APPROVAL_MESSAGE = 'Are you sure to restore the document?';

  constructor(
    public activeModal: NgbActiveModal, 
    private httpService: HttpService, 
    private toastr: ToastrService
  ) {}
  
  get confirmationMessage(): string {
    // If a custom message is provided, use it
    if (this.message) {
      return this.message;
    }
    
    // Otherwise use default messages
    if (this.confirmationType === ConfirmationType.DELETE_LEAD) {
      return this.DELETE_LEAD_MESSAGE;
    } else if (this.confirmationType === ConfirmationType.DELETE_QUERY) {
      return this.DELETE_QUERY_MESSAGE;
    } else if (this.confirmationType === ConfirmationType.ATTACH_DOCUMENTS) {
      return this.ATTACH_DOCUMENTS_MESSAGE;
    } else if (this.confirmationType === ConfirmationType.ATTACH_GENLINK) {
      return this.ATTACH_GENLINK_MESSAGE;
    } else if (this.confirmationType === ConfirmationType.CHANGES_MADE) {
      return this.CHANGES_MADE_MESSAGE;
    } else if (this.confirmationType === ConfirmationType.RESET_PASSWORD) {
      return this.RESET_PASSWORD_MESSAGE;
    }else if (this.confirmationType === ConfirmationType.DELETE_DOCUMENT) {
      return this.DELETE_DOCUMENT_MESSAGE;
    }else if (this.confirmationType === ConfirmationType.DOWNLOAD_DOCUMENT) {
      return this.DOWNLOAD_DOCUMENT_MESSAGE;
    }else if (this.confirmationType === ConfirmationType.DELETE_TEAM_MEMBER) {
      return this.DELETE_TEAM_MEMBER;
    } 
    else if (this.confirmationType === ConfirmationType.DELETE_APPROVAL) {
      return this.DELETE_APPROVAL_MESSAGE;
    }
    else if (this.confirmationType === ConfirmationType.RESTORE_APPROVAL) {
      return this.RESTORE_APPROVAL_MESSAGE;
    }
    else {
      return '';
    }
  }

  confirm() {
    if (this.confirmationType === ConfirmationType.DELETE_LEAD) {
      this.deleteLead();
    }
    else if (this.confirmationType === ConfirmationType.DELETE_QUERY) {
      this.deleteQuery();
    }
    else if (this.confirmationType === ConfirmationType.ATTACH_GENLINK) {
      this.genLink();
    }
    else if (this.confirmationType === ConfirmationType.CHANGES_MADE) {
      this.changeClose();
    }
    else if (this.confirmationType === ConfirmationType.RESET_PASSWORD) {
      this.resetPassword();
    }
    else if (this.confirmationType === ConfirmationType.DELETE_TEAM_MEMBER) {
      this.deleteTeamMember();
    }
    else if (this.confirmationType === ConfirmationType.DELETE_DOCUMENT) {
       this.deleteDocument();
    }
    else if (this.confirmationType === ConfirmationType.DOWNLOAD_DOCUMENT) {
      this.downloadDocument();
    }
    else if (this.confirmationType === ConfirmationType.UPDATE_DOCUMENT_INFO) {
      this.updateDocumentInfo();
    }
    else if (this.confirmationType === ConfirmationType.UPDATE_DOCUMENT_TAGS) {
      this.updateDocumentTags();
    } 
    else if (this.confirmationType === ConfirmationType.DELETE_APPROVAL) {
      this.deleteApprovalDocument();
    }
    else if (this.confirmationType === ConfirmationType.RESTORE_APPROVAL) {
      this.restoreApprovalDocument();
    }
    else {
      this.attachDocuments();
    }
  }

  deleteTeamMember() {
    // console.log('memDel',this.memData);
    let id = this.memData?.id;

    this.httpService.sendRePatchRequest(URLUtils.deleteMember(id),{"memberId": this.memData.id}).subscribe((res: any) => {                        
      // if (res.error === false) {
      //   this.toastr.success('Team member deleted successfully');
      // }
      // else {
      //   this.toastr.error(res.msg);
      // }
      this.activeModal.close('deleted'); // Close modal and return status
    });
  }

  changeClose(){
    this.activeModal.close('change_made');
  }

  resetPassword() {
     this.httpService.sendRePostRequest(URLUtils.resetMemberPassword, {"memberId": this.memData.id}).subscribe((res: any) => {
    if (res.error === false) {
      //this.toastr.success('You have successfully initiated password reset');
    }
    else {
     // this.toastr.error(res.msg);
    }
    this.activeModal.close('reset_password'); // Close modal and return status
  });
}
  genLink(){
    this.activeModal.close('genlink');
  }
  
  deleteQuery() {
    this.uid = localStorage.getItem('profuid');

    this.httpService.sendReDeleteRequest(URLUtils.deleteQuery(this.queryId, this.uid)).subscribe((res: any) => {
      if (res.error === false) {
        this.toastr.success('Inquiry deleted successfully');
      }
      else {
        this.toastr.error(res.msg);
      }
      this.activeModal.close('deleted'); // Close modal and return status
    });
  }

  deleteLead() {
    this.httpService.sendDeleteRequest(URLUtils.deleteLeads(this.leadId)).subscribe((res: any) => {
      if (res.error === false) {
        this.toastr.success('Lead deleted successfully');
      }
      else {
        this.toastr.error(res.msg);
      }
      this.activeModal.close('deleted'); // Close modal and return status
    });
  }
  
  attachDocuments() {
    // Here you would implement the API call to attach documents to matters
    // For example:
    // this.httpService.sendPostRequest(URLUtils.attachDocumentsToMatters(uid, this.selectedMatterIds, documentIds))
    //   .subscribe((response: any) => {
    //     this.toastr.success('Documents attached successfully');
    //     this.activeModal.close('attached'); // Close modal and return status
    //   });
    
    // For now, just simulate success
    this.activeModal.close('attached');
  }

  getLeads() {
    this.httpService.sendGetRequest(URLUtils.leadslawyers()).subscribe((response: any) => {
      //console.log(response.data);
    });
  }
  
  cancel() {
    this.activeModal.dismiss('Cancelled');
  }

  //document related methods
   deleteDocument() {
    if (this.documentData) {
      // Pass the document data back to the parent component for actual deletion
      this.activeModal.close({ action: 'delete_document', data: this.documentData });
    }
  }

  downloadDocument() {
    if (this.documentData) {
      // Pass the document data back to the parent component for actual download
      this.activeModal.close({ action: 'download_document', data: this.documentData });
    }
  }

  updateDocumentInfo() {
    if (this.documentData) {
      // Pass the document data back to the parent component for actual update
      this.activeModal.close({ action: 'update_document_info', data: this.documentData });
    }
  }

  updateDocumentTags() {
    if (this.documentData) {
      // Pass the document data back to the parent component for actual tags update
      this.activeModal.close({ action: 'update_document_tags', data: this.documentData });
    }
  }
  deleteApprovalDocument() {
   // console.log('documentData', this.documentData);
    let documentId: any = {
      docid: this.documentData.id,
      doctype: this.documentData.doctype
    };
    this.httpService.sendPostRequest(URLUtils.deleteApprovalDelete, documentId).subscribe((res: any) => {
      if (res.error)
        this.toastr.error(res.msg);
      else
        this.toastr.success(res.msg);
    });
    this.activeModal.close({ action: 'delete_approval', data: this.documentData });
  }
  restoreApprovalDocument() {
    let documentId: any = {
      docid: this.documentData.id,
      doctype: this.documentData.doctype
    };

    this.httpService.sendPostRequest(URLUtils.deleteApprovalRestore, documentId).subscribe((res: any) => {
      if (res.error)
        this.toastr.error(res.msg);
      else
        this.toastr.success(res.msg);
    });
    this.activeModal.close({ action: 'restore_approval', data: this.documentData });
  }
}